export function IconExport({
  fill,
  height = 19,
  width = 19
}: {
  fill?: string;
  height?: number;
  width?: number;
}) {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 19 19"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // eslint-disable-next-line max-len
        d="M9.07617 12.1123L5.32617 8.3623L6.37617 7.27481L8.32617 9.2248V3.1123H9.82617V9.2248L11.7762 7.27481L12.8262 8.3623L9.07617 12.1123ZM4.57617 15.1123C4.16367 15.1123 3.81055 14.9654 3.5168 14.6717C3.22305 14.3779 3.07617 14.0248 3.07617 13.6123V11.3623H4.57617V13.6123H13.5762V11.3623H15.0762V13.6123C15.0762 14.0248 14.9293 14.3779 14.6355 14.6717C14.3418 14.9654 13.9887 15.1123 13.5762 15.1123H4.57617Z"
        fill={fill || '#239706'}
      />
    </svg>
  );
}
